import { api } from '@/src/shared/lib/api'

export async function paymentSolidGateCardDelete<ApiResponse>(cardId: number) {
  const url = api.appURL('payment/solid_gate/card/' + cardId)
  const response = await api.delete<ApiResponse>(url, {})
  return api.parseRespone<ApiResponse>(response)
}
